package world.phantasmal.web.viewer.models

/** A named BB weapon and the ItemPMT model/texture pair used to render it. */
internal data class ViewerWeaponCatalogEntry(
    val itemTypeId: Int,
    val name: String,
    val modelIndex: Int,
    val textureIndex: Int,
    val weaponKind: Int,
)

/**
 * Generated by :web:assets-generation:generateViewerWeaponCatalog.
 * Multiple names intentionally remain when they share the same model and texture.
 */
internal val VIEWER_WEAPON_CATALOG: List<ViewerWeaponCatalogEntry> = listOf(
    ViewerWeaponCatalogEntry(0x00CA00, "5th Anniv. Blade", 231, 231, 1),
    ViewerWeaponCatalogEntry(0x001001, "Agito (1975)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x001005, "Agito (1977)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x001006, "Agito (1980)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x001002, "Agito (1983)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x001004, "Agito (1991)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x001003, "Agito (2001)", 15, 271, 16),
    ViewerWeaponCatalogEntry(0x00CC00, "Akiko's Cleaver", 233, 233, 2),
    ViewerWeaponCatalogEntry(0x001600, "Akiko's Frying Pan", 21, 21, 16),
    ViewerWeaponCatalogEntry(0x002A00, "Akiko's Wok", 41, 41, 1),
    ViewerWeaponCatalogEntry(0x000B06, "Alive Aqhu", 147, 147, 11),
    ViewerWeaponCatalogEntry(0x00A400, "Amore Rose", 195, 195, 18),
    ViewerWeaponCatalogEntry(0x002700, "Ancient Saber", 38, 38, 1),
    ViewerWeaponCatalogEntry(0x009900, "Angel Harp", 190, 190, 7),
    ViewerWeaponCatalogEntry(0x00D200, "Ano Bazooka", 239, 239, 17),
    ViewerWeaponCatalogEntry(0x006600, "Ano Rifle", 101, 101, 7),
    ViewerWeaponCatalogEntry(0x004600, "Anti Android Rifle", 69, 69, 7),
    ViewerWeaponCatalogEntry(0x000904, "Arms", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x000801, "Assault", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x000408, "Asteron Belt", 257, 257, 4),
    ViewerWeaponCatalogEntry(0x008902, "Asuka", 172, 172, 15),
    ViewerWeaponCatalogEntry(0x000601, "Autogun", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x00A900, "AXE", 31, 31, 1),
    ViewerWeaponCatalogEntry(0x00D400, "Bamboo Spear", 241, 241, 4),
    ViewerWeaponCatalogEntry(0x006700, "Baranz Launcher", 102, 102, 9),
    ViewerWeaponCatalogEntry(0x000C02, "Baton", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x000B04, "Battle Verge", 146, 146, 11),
    ViewerWeaponCatalogEntry(0x00D900, "Battledore", 246, 246, 1),
    ViewerWeaponCatalogEntry(0x007E00, "BAZOOKA", 19, 19, 9),
    ViewerWeaponCatalogEntry(0x000703, "Beam", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x004D00, "Belra Cannon", 76, 76, 9),
    ViewerWeaponCatalogEntry(0x000403, "Berdys", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x003D00, "Berdysh", 60, 60, 4),
    ViewerWeaponCatalogEntry(0x002F01, "Black King Bar", 46, 288, 14),
    ViewerWeaponCatalogEntry(0x000302, "Blade", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x007200, "BLADE", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x000305, "Blade Dance", 162, 162, 3),
    ViewerWeaponCatalogEntry(0x000702, "Blaster", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x000306, "Bloody Art", 161, 161, 3),
    ViewerWeaponCatalogEntry(0x009303, "Bluefull Card", 178, 280, 18),
    ViewerWeaponCatalogEntry(0x00A200, "Booma's Claw", 184, 184, 13),
    ViewerWeaponCatalogEntry(0x006800, "Branch of Pakupaku", 103, 103, 11),
    ViewerWeaponCatalogEntry(0x000101, "Brand", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x000607, "Bravace", 126, 126, 6),
    ViewerWeaponCatalogEntry(0x000B05, "Brave Hammer", 145, 145, 11),
    ViewerWeaponCatalogEntry(0x000202, "Breaker", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x001B00, "Bringer's Rifle", 26, 26, 7),
    ViewerWeaponCatalogEntry(0x000405, "Brionac", 165, 165, 4),
    ViewerWeaponCatalogEntry(0x005900, "Broom", 88, 88, 11),
    ViewerWeaponCatalogEntry(0x001501, "Burning Visit", 20, 290, 9),
    ViewerWeaponCatalogEntry(0x000102, "Buster", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x00D700, "Butterfly Net", 244, 244, 4),
    ViewerWeaponCatalogEntry(0x002200, "Caduceus", 33, 33, 11),
    ViewerWeaponCatalogEntry(0x000204, "Calibur", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x000A00, "Cane", 9, 9, 10),
    ViewerWeaponCatalogEntry(0x007900, "CANE", 9, 9, 10),
    ViewerWeaponCatalogEntry(0x000902, "Cannon", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x00C000, "Cannon Rouge", 221, 221, 17),
    ViewerWeaponCatalogEntry(0x00A700, "CARDS", 151, 151, 18),
    ViewerWeaponCatalogEntry(0x002100, "Chain Sawd", 32, 32, 2),
    ViewerWeaponCatalogEntry(0x006400, "Chameleon Scythe", 99, 99, 4),
    ViewerWeaponCatalogEntry(0x007D00, "CLAW", 12, 12, 13),
    ViewerWeaponCatalogEntry(0x000203, "Claymore", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x00C300, "Clio", 224, 224, 10),
    ViewerWeaponCatalogEntry(0x000A03, "Club", 9, 9, 10),
    ViewerWeaponCatalogEntry(0x000A04, "Club of Laconium", 142, 142, 10),
    ViewerWeaponCatalogEntry(0x000A06, "Club of Zumiuran", 144, 144, 10),
    ViewerWeaponCatalogEntry(0x00B200, "Commander Blade", 207, 207, 1),
    ViewerWeaponCatalogEntry(0x003500, "Crazy Tune", 52, 52, 2),
    ViewerWeaponCatalogEntry(0x000307, "Cross Scar", 163, 163, 3),
    ViewerWeaponCatalogEntry(0x000905, "Crush Bullet", 136, 136, 9),
    ViewerWeaponCatalogEntry(0x000606, "Custom Ray ver.OO", 127, 127, 6),
    ViewerWeaponCatalogEntry(0x000502, "Cutter", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x000300, "Dagger", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x00AE00, "Daisy Chain", 203, 203, 2),
    ViewerWeaponCatalogEntry(0x008C03, "Dancing Hitogata", 177, 177, 18),
    ViewerWeaponCatalogEntry(0x009F00, "Dark Bridge", 189, 189, 11),
    ViewerWeaponCatalogEntry(0x009D00, "Dark Flow", 179, 179, 2),
    ViewerWeaponCatalogEntry(0x009E00, "Dark Meteor", 197, 197, 9),
    ViewerWeaponCatalogEntry(0x00C800, "Daylight Scar", 229, 229, 3),
    ViewerWeaponCatalogEntry(0x000105, "DB's Saber", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009000, "DB's Saber (3062)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009003, "DB's Saber (3064)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009001, "DB's Saber (3067)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009002, "DB's Saber (3069 Chris)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009004, "DB's Saber (3069 Torato)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009006, "DB's Saber (3070)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009005, "DB's Saber (3073)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009007, "DB's Saber (3075)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x009008, "DB's Saber (3077)", 153, 153, 1),
    ViewerWeaponCatalogEntry(0x00C900, "Decalog", 230, 230, 10),
    ViewerWeaponCatalogEntry(0x001A00, "Delsaber's Buster", 25, 25, 1),
    ViewerWeaponCatalogEntry(0x009A00, "Demolition Comet", 182, 182, 14),
    ViewerWeaponCatalogEntry(0x005700, "Demonic Fork", 86, 86, 11),
    ViewerWeaponCatalogEntry(0x000504, "Diska", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x000507, "Diska of Braveman", 168, 168, 5),
    ViewerWeaponCatalogEntry(0x000506, "Diska of Liberator", 169, 169, 5),
    ViewerWeaponCatalogEntry(0x003000, "Double Cannon", 47, 47, 14),
    ViewerWeaponCatalogEntry(0x000E00, "Double Saber", 13, 13, 14),
    ViewerWeaponCatalogEntry(0x000207, "Dragon Slayer", 159, 159, 2),
    ViewerWeaponCatalogEntry(0x006000, "Dragon's Claw", 95, 95, 13),
    ViewerWeaponCatalogEntry(0x004A00, "Drill Launcher", 73, 73, 7),
    ViewerWeaponCatalogEntry(0x004B01, "Dual Bird", 256, 256, 8),
    ViewerWeaponCatalogEntry(0x000107, "Durandal", 152, 152, 1),
    ViewerWeaponCatalogEntry(0x000C07, "Earth Wand: Brownie", 264, 264, 12),
    ViewerWeaponCatalogEntry(0x000303, "Edge", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x001C00, "Egg Blaster", 27, 27, 7),
    ViewerWeaponCatalogEntry(0x002C00, "Elysion", 43, 43, 1),
    ViewerWeaponCatalogEntry(0x005100, "Evil Curst", 80, 80, 1),
    ViewerWeaponCatalogEntry(0x00AC00, "Excalibur", 201, 201, 1),
    ViewerWeaponCatalogEntry(0x005601, "Fatsia", 85, 287, 11),
    ViewerWeaponCatalogEntry(0x000907, "Final Impact", 137, 137, 9),
    ViewerWeaponCatalogEntry(0x000C04, "Fire Scepter: Agni", 148, 148, 12),
    ViewerWeaponCatalogEntry(0x00B900, "Flamberge", 214, 214, 1),
    ViewerWeaponCatalogEntry(0x001500, "Flame Visit", 20, 20, 9),
    ViewerWeaponCatalogEntry(0x00BC00, "Flapjack Flapper", 217, 217, 3),
    ViewerWeaponCatalogEntry(0x003F00, "Flight Cutter", 62, 62, 5),
    ViewerWeaponCatalogEntry(0x004000, "Flight Fan", 63, 63, 5),
    ViewerWeaponCatalogEntry(0x000205, "Flowen's Sword", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F00, "Flowen's Sword (3060)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F01, "Flowen's Sword (3064)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F02, "Flowen's Sword (3067)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F03, "Flowen's Sword (3073)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F04, "Flowen's Sword (3077)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F08, "Flowen's Sword (3079)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F05, "Flowen's Sword (3082)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F06, "Flowen's Sword (3083)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x008F07, "Flowen's Sword (3084)", 158, 158, 2),
    ViewerWeaponCatalogEntry(0x006F00, "Flower Bouquet", 110, 110, 1),
    ViewerWeaponCatalogEntry(0x005200, "Flower Cane", 81, 81, 10),
    ViewerWeaponCatalogEntry(0x004500, "Frozen Shooter", 68, 68, 7),
    ViewerWeaponCatalogEntry(0x00A000, "G-Assassin's Sabers", 187, 187, 15),
    ViewerWeaponCatalogEntry(0x000407, "Gae Bolg", 166, 166, 4),
    ViewerWeaponCatalogEntry(0x009600, "Gal Wind", 194, 194, 18),
    ViewerWeaponCatalogEntry(0x000108, "Galatine", 252, 252, 1),
    ViewerWeaponCatalogEntry(0x006E00, "Game Magazine", 109, 109, 12),
    ViewerWeaponCatalogEntry(0x000803, "Gatling", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x00BD00, "Getsugasan", 218, 218, 4),
    ViewerWeaponCatalogEntry(0x009100, "Gi Gue Bazooka", 174, 174, 17),
    ViewerWeaponCatalogEntry(0x00A202, "Gigobooma's Claw", 186, 186, 13),
    ViewerWeaponCatalogEntry(0x000201, "Gigush", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x003001, "Girasole", 259, 259, 14),
    ViewerWeaponCatalogEntry(0x000104, "Gladius", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x000402, "Glaive", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x00C500, "Glide Divine", 226, 226, 11),
    ViewerWeaponCatalogEntry(0x00A201, "Gobooma's Claw", 185, 185, 13),
    ViewerWeaponCatalogEntry(0x00DC00, "Great Bouquet", 249, 249, 1),
    ViewerWeaponCatalogEntry(0x009301, "Greenill Card", 178, 278, 18),
    ViewerWeaponCatalogEntry(0x009200, "Guardianna", 176, 176, 18),
    ViewerWeaponCatalogEntry(0x008B01, "Guilty Light", 139, 139, 17),
    ViewerWeaponCatalogEntry(0x004B00, "Guld Milla", 74, 74, 8),
    ViewerWeaponCatalogEntry(0x007500, "GUN", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x000404, "Gungnir", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x00B600, "Guren", 211, 211, 16),
    ViewerWeaponCatalogEntry(0x000806, "H&S25 Justice", 133, 133, 8),
    ViewerWeaponCatalogEntry(0x000401, "Halbert", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x008100, "HAMMER", 42, 42, 16),
    ViewerWeaponCatalogEntry(0x00DB00, "Hammer", 248, 248, 2),
    ViewerWeaponCatalogEntry(0x000600, "Handgun", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x004200, "Handgun: Guld", 65, 65, 6),
    ViewerWeaponCatalogEntry(0x004300, "Handgun: Milla", 66, 66, 6),
    ViewerWeaponCatalogEntry(0x008600, "HARISEN", 39, 39, 16),
    ViewerWeaponCatalogEntry(0x002800, "Harisen Battle Fan", 39, 39, 16),
    ViewerWeaponCatalogEntry(0x006900, "Heart of Poumn", 104, 104, 13),
    ViewerWeaponCatalogEntry(0x001E00, "Heaven Punisher", 29, 29, 6),
    ViewerWeaponCatalogEntry(0x00BF00, "Heaven Striker", 220, 220, 6),
    ViewerWeaponCatalogEntry(0x005300, "Hildebear's Cane", 82, 82, 11),
    ViewerWeaponCatalogEntry(0x005400, "Hildeblue's Cane", 83, 83, 11),
    ViewerWeaponCatalogEntry(0x008C02, "Hitogata", 177, 177, 18),
    ViewerWeaponCatalogEntry(0x001300, "Holy Ray", 18, 18, 7),
    ViewerWeaponCatalogEntry(0x003100, "Huge Battle Fan", 48, 48, 2),
    ViewerWeaponCatalogEntry(0x000C05, "Ice Staff: Dagon", 149, 149, 12),
    ViewerWeaponCatalogEntry(0x003C00, "Imperial Pick", 59, 59, 4),
    ViewerWeaponCatalogEntry(0x001400, "Inferno Bazooka", 19, 19, 9),
    ViewerWeaponCatalogEntry(0x004E01, "Iron Faust", 77, 291, 9),
    ViewerWeaponCatalogEntry(0x000508, "Izmaela", 265, 265, 5),
    ViewerWeaponCatalogEntry(0x008800, "J-CUTTER", 62, 62, 5),
    ViewerWeaponCatalogEntry(0x00D600, "Jitte", 243, 243, 1),
    ViewerWeaponCatalogEntry(0x00B800, "Jizai", 213, 213, 15),
    ViewerWeaponCatalogEntry(0x000707, "Justy-23ST", 129, 129, 7),
    ViewerWeaponCatalogEntry(0x000106, "Kaladbolg", 154, 154, 1),
    ViewerWeaponCatalogEntry(0x008A02, "Kamui", 155, 155, 16),
    ViewerWeaponCatalogEntry(0x00D500, "Kan'ei Tsuho", 242, 242, 18),
    ViewerWeaponCatalogEntry(0x008700, "KATANA", 15, 15, 16),
    ViewerWeaponCatalogEntry(0x000301, "Knife", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x008C04, "Kunai", 266, 266, 18),
    ViewerWeaponCatalogEntry(0x00B400, "Kusanagi", 209, 209, 1),
    ViewerWeaponCatalogEntry(0x000807, "L&K14 Combat", 132, 132, 8),
    ViewerWeaponCatalogEntry(0x001402, "L&K38 Combat", 261, 261, 9),
    ViewerWeaponCatalogEntry(0x002001, "Laconium Axe", 263, 263, 2),
    ViewerWeaponCatalogEntry(0x00AB00, "Lame d'Argent", 200, 200, 1),
    ViewerWeaponCatalogEntry(0x000704, "Laser", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x000206, "Last Survivor", 160, 160, 2),
    ViewerWeaponCatalogEntry(0x004301, "Last Swan", 255, 255, 6),
    ViewerWeaponCatalogEntry(0x000903, "Launcher", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x00A600, "LAUNCHER", 138, 138, 17),
    ViewerWeaponCatalogEntry(0x003800, "Lavis Blade", 55, 55, 3),
    ViewerWeaponCatalogEntry(0x001F00, "Lavis Cannon", 30, 30, 1),
    ViewerWeaponCatalogEntry(0x00B100, "Le Cogneur", 206, 206, 7),
    ViewerWeaponCatalogEntry(0x000602, "Lockgun", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x006E01, "LOGiN", 109, 293, 12),
    ViewerWeaponCatalogEntry(0x000A07, "Lollipop", 268, 268, 10),
    ViewerWeaponCatalogEntry(0x000805, "M&A60 Vise", 134, 134, 8),
    ViewerWeaponCatalogEntry(0x000A02, "Mace", 9, 9, 10),
    ViewerWeaponCatalogEntry(0x000A05, "Mace of Adaman", 143, 143, 10),
    ViewerWeaponCatalogEntry(0x003A00, "Madam's Parasol", 57, 57, 4),
    ViewerWeaponCatalogEntry(0x003B00, "Madam's Umbrella", 58, 58, 4),
    ViewerWeaponCatalogEntry(0x002400, "Magical Piece", 35, 35, 12),
    ViewerWeaponCatalogEntry(0x00BE00, "Maguwa", 219, 219, 4),
    ViewerWeaponCatalogEntry(0x008C01, "Mahu", 175, 175, 18),
    ViewerWeaponCatalogEntry(0x005F00, "Marina's Bag", 94, 94, 12),
    ViewerWeaponCatalogEntry(0x006D00, "Maser Beam", 108, 108, 9),
    ViewerWeaponCatalogEntry(0x004201, "Master Raven", 254, 254, 6),
    ViewerWeaponCatalogEntry(0x000800, "Mechgun", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x007700, "MECHGUN", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x002201, "Mercurius Rod", 250, 250, 11),
    ViewerWeaponCatalogEntry(0x002E00, "Meteor Cudgel", 45, 45, 14),
    ViewerWeaponCatalogEntry(0x00C100, "Meteor Rouge", 222, 222, 17),
    ViewerWeaponCatalogEntry(0x000906, "Meteor Smash", 135, 135, 9),
    ViewerWeaponCatalogEntry(0x00B000, "Mille Marteaux", 205, 205, 8),
    ViewerWeaponCatalogEntry(0x002F00, "Monkey King Bar", 46, 46, 14),
    ViewerWeaponCatalogEntry(0x008200, "MOON", 78, 78, 10),
    ViewerWeaponCatalogEntry(0x009400, "Morning Glory", 188, 188, 13),
    ViewerWeaponCatalogEntry(0x00C700, "Murasame", 228, 228, 16),
    ViewerWeaponCatalogEntry(0x008900, "Musashi", 170, 170, 15),
    ViewerWeaponCatalogEntry(0x007F00, "NEEDLE", 17, 17, 7),
    ViewerWeaponCatalogEntry(0x000D02, "Nei's Claw", 12, 273, 13),
    ViewerWeaponCatalogEntry(0x009B00, "Nei's Claw", 193, 193, 13),
    ViewerWeaponCatalogEntry(0x00CF00, "Nice Shot", 236, 236, 4),
    ViewerWeaponCatalogEntry(0x008D00, "NUG2000-Bazooka", 141, 141, 17),
    ViewerWeaponCatalogEntry(0x00AF00, "Ophelie Seize", 204, 204, 6),
    ViewerWeaponCatalogEntry(0x009307, "Oran Card", 178, 284, 18),
    ViewerWeaponCatalogEntry(0x001000, "Orotiagito", 15, 15, 16),
    ViewerWeaponCatalogEntry(0x001900, "P-Arms' Blade", 24, 24, 3),
    ViewerWeaponCatalogEntry(0x000103, "Pallasch", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x006100, "Panther's Claw", 96, 96, 13),
    ViewerWeaponCatalogEntry(0x004E00, "Panzer Faust", 77, 77, 9),
    ViewerWeaponCatalogEntry(0x000400, "Partisan", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x007300, "PARTISAN", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x009500, "Partisan of Lightning", 181, 181, 14),
    ViewerWeaponCatalogEntry(0x000D03, "Phoenix Claw", 258, 258, 13),
    ViewerWeaponCatalogEntry(0x008B03, "Phonon Maser", 262, 262, 17),
    ViewerWeaponCatalogEntry(0x000D00, "Photon Claw", 12, 12, 13),
    ViewerWeaponCatalogEntry(0x008B00, "Photon Launcher", 138, 138, 17),
    ViewerWeaponCatalogEntry(0x000B02, "Pillar", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x009305, "Pinkal Card", 178, 282, 18),
    ViewerWeaponCatalogEntry(0x005D00, "Plantain Fan", 92, 92, 12),
    ViewerWeaponCatalogEntry(0x006300, "Plantain Huge Fan", 98, 98, 4),
    ViewerWeaponCatalogEntry(0x005600, "Plantain Leaf", 85, 85, 11),
    ViewerWeaponCatalogEntry(0x000B01, "Pole", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x006D01, "Power Maser", 108, 289, 9),
    ViewerWeaponCatalogEntry(0x005A00, "Prophets of Motav", 89, 89, 12),
    ViewerWeaponCatalogEntry(0x001D00, "Psycho Wand", 28, 28, 11),
    ViewerWeaponCatalogEntry(0x008300, "PSYCHOGUN", 72, 72, 8),
    ViewerWeaponCatalogEntry(0x008400, "PUNCH", 70, 70, 8),
    ViewerWeaponCatalogEntry(0x009304, "Purplenum Card", 178, 281, 18),
    ViewerWeaponCatalogEntry(0x005500, "Rabbit Wand", 84, 84, 11),
    ViewerWeaponCatalogEntry(0x00DA00, "Racket", 247, 247, 1),
    ViewerWeaponCatalogEntry(0x00AD00, "Rage de Feu", 202, 202, 8),
    ViewerWeaponCatalogEntry(0x001007, "Raikiri", 15, 292, 16),
    ViewerWeaponCatalogEntry(0x000603, "Railgun", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x009C00, "Rainbow Baton", 191, 191, 5),
    ViewerWeaponCatalogEntry(0x001401, "Rambling May", 251, 251, 9),
    ViewerWeaponCatalogEntry(0x00A100, "Rappy's Fan", 196, 196, 5),
    ViewerWeaponCatalogEntry(0x000604, "Raygun", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x003900, "Red Dagger", 56, 56, 3),
    ViewerWeaponCatalogEntry(0x004400, "Red Handgun", 67, 67, 6),
    ViewerWeaponCatalogEntry(0x004C00, "Red Mechgun", 75, 75, 8),
    ViewerWeaponCatalogEntry(0x003E00, "Red Partisan", 61, 61, 4),
    ViewerWeaponCatalogEntry(0x002D00, "Red Saber", 44, 44, 1),
    ViewerWeaponCatalogEntry(0x008B02, "Red Scorpio", 140, 140, 17),
    ViewerWeaponCatalogEntry(0x004100, "Red Slicer", 64, 64, 5),
    ViewerWeaponCatalogEntry(0x003400, "Red Sword", 51, 51, 2),
    ViewerWeaponCatalogEntry(0x009306, "Redria Card", 178, 283, 18),
    ViewerWeaponCatalogEntry(0x000802, "Repeater", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x000708, "Rianov 303SNR", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x000709, "Rianov 303SNR-1", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x00070A, "Rianov 303SNR-2", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x00070B, "Rianov 303SNR-3", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x00070C, "Rianov 303SNR-4", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x00070D, "Rianov 303SNR-5", 260, 260, 7),
    ViewerWeaponCatalogEntry(0x000700, "Rifle", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x007600, "RIFLE", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x009800, "Rika's Claw", 192, 192, 13),
    ViewerWeaponCatalogEntry(0x000304, "Ripper", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x004700, "Rocket Punch", 70, 70, 8),
    ViewerWeaponCatalogEntry(0x000B00, "Rod", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x007A00, "ROD", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x00A300, "Ruby Bullet", 183, 183, 6),
    ViewerWeaponCatalogEntry(0x001800, "S-Beat's Blade", 23, 23, 3),
    ViewerWeaponCatalogEntry(0x008E00, "S-Berill's Hands #0", 173, 173, 3),
    ViewerWeaponCatalogEntry(0x008E01, "S-Berill's Hands #1", 173, 173, 3),
    ViewerWeaponCatalogEntry(0x006200, "S-Red's Blade", 97, 97, 3),
    ViewerWeaponCatalogEntry(0x000100, "Saber", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x007000, "SABER", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x00B500, "Sacred Duster", 210, 210, 0),
    ViewerWeaponCatalogEntry(0x004800, "Samba Maracas", 71, 71, 8),
    ViewerWeaponCatalogEntry(0x008A00, "Sange", 156, 156, 16),
    ViewerWeaponCatalogEntry(0x008903, "Sange & Yasha", 198, 198, 15),
    ViewerWeaponCatalogEntry(0x000503, "Sawcer", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x000C03, "Scepter", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x008000, "SCYTHE", 16, 16, 4),
    ViewerWeaponCatalogEntry(0x003300, "Sealed J-Sword", 50, 50, 2),
    ViewerWeaponCatalogEntry(0x00C600, "Shichishito", 227, 227, 16),
    ViewerWeaponCatalogEntry(0x000900, "Shot", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x007800, "SHOT", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x00B700, "Shouren", 212, 212, 16),
    ViewerWeaponCatalogEntry(0x000D01, "Silence Claw", 12, 272, 13),
    ViewerWeaponCatalogEntry(0x00C400, "Siren Glass Hammer", 225, 225, 11),
    ViewerWeaponCatalogEntry(0x009302, "Skyly Card", 178, 279, 18),
    ViewerWeaponCatalogEntry(0x000500, "Slicer", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x007400, "SLICER", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x000505, "Slicer of Assassin", 167, 167, 5),
    ViewerWeaponCatalogEntry(0x00AA00, "Slicer of Fanatic", 199, 199, 5),
    ViewerWeaponCatalogEntry(0x00BB00, "Snake Spire", 216, 216, 4),
    ViewerWeaponCatalogEntry(0x000701, "Sniper", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x004501, "Snow Queen", 68, 275, 7),
    ViewerWeaponCatalogEntry(0x00C200, "Solferino", 223, 223, 12),
    ViewerWeaponCatalogEntry(0x000F03, "Sonic Knuckle", 14, 14, 0),
    ViewerWeaponCatalogEntry(0x001700, "Sorcerer's Cane", 22, 22, 11),
    ViewerWeaponCatalogEntry(0x001101, "Soul Banish", 16, 16, 4),
    ViewerWeaponCatalogEntry(0x001100, "Soul Eater", 16, 16, 4),
    ViewerWeaponCatalogEntry(0x000501, "Spinner", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x000901, "Spread", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x001200, "Spread Needle", 17, 17, 7),
    ViewerWeaponCatalogEntry(0x000C01, "Staff", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x000E01, "Stag Cutlery", 13, 13, 14),
    ViewerWeaponCatalogEntry(0x000A01, "Stick", 9, 9, 10),
    ViewerWeaponCatalogEntry(0x002300, "Sting Tip", 34, 34, 1),
    ViewerWeaponCatalogEntry(0x000C06, "Storm Wand: Indra", 150, 150, 12),
    ViewerWeaponCatalogEntry(0x000B03, "Striker", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x005800, "Striker of Chao", 87, 87, 11),
    ViewerWeaponCatalogEntry(0x004F00, "Summit Moon", 78, 78, 10),
    ViewerWeaponCatalogEntry(0x002600, "Suppressed Gun", 37, 37, 6),
    ViewerWeaponCatalogEntry(0x000200, "Sword", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x007100, "SWORD", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x00A500, "SWORDS", 172, 172, 15),
    ViewerWeaponCatalogEntry(0x00D300, "Synthesizer", 240, 240, 4),
    ViewerWeaponCatalogEntry(0x00D800, "Syringe", 245, 245, 18),
    ViewerWeaponCatalogEntry(0x008C00, "Talis", 151, 151, 18),
    ViewerWeaponCatalogEntry(0x00CD00, "Tanegashima", 234, 234, 7),
    ViewerWeaponCatalogEntry(0x002500, "Technical Crozier", 36, 36, 12),
    ViewerWeaponCatalogEntry(0x000608, "Tension Blaster", 267, 267, 6),
    ViewerWeaponCatalogEntry(0x005B00, "The Sigh of a God", 90, 90, 12),
    ViewerWeaponCatalogEntry(0x002B00, "Toy Hammer", 42, 42, 16),
    ViewerWeaponCatalogEntry(0x00CE00, "Tree Clippers", 235, 235, 4),
    ViewerWeaponCatalogEntry(0x003200, "Tsumikiri J-Sword", 49, 49, 2),
    ViewerWeaponCatalogEntry(0x007C00, "TWIN", 13, 13, 14),
    ViewerWeaponCatalogEntry(0x005E00, "Twin Blaze", 93, 93, 14),
    ViewerWeaponCatalogEntry(0x000E02, "Twin Brand", 13, 13, 14),
    ViewerWeaponCatalogEntry(0x003600, "Twin Chakram", 53, 53, 3),
    ViewerWeaponCatalogEntry(0x004900, "Twin Psychogun", 72, 72, 8),
    ViewerWeaponCatalogEntry(0x005C00, "Twinkle Star", 91, 91, 12),
    ViewerWeaponCatalogEntry(0x000309, "Two Kamui", 155, 155, 3),
    ViewerWeaponCatalogEntry(0x00E200, "TypeBL/Blade", 2, 2, 3),
    ViewerWeaponCatalogEntry(0x00E600, "TypeCL/Claw", 12, 294, 13),
    ViewerWeaponCatalogEntry(0x00E502, "TypeDS", 11, 11, 14),
    ViewerWeaponCatalogEntry(0x00E500, "TypeDS/D.Saber", 13, 13, 14),
    ViewerWeaponCatalogEntry(0x00E501, "TypeDS/Rod", 10, 10, 14),
    ViewerWeaponCatalogEntry(0x00E800, "TypeGU/Hand", 5, 5, 6),
    ViewerWeaponCatalogEntry(0x00E801, "TypeGU/Mechgun", 7, 7, 6),
    ViewerWeaponCatalogEntry(0x00E400, "TypeHA/Halbert", 3, 3, 4),
    ViewerWeaponCatalogEntry(0x00E401, "TypeHA/Rod", 10, 10, 4),
    ViewerWeaponCatalogEntry(0x00DF02, "TypeJS/J-Sword", 15, 15, 16),
    ViewerWeaponCatalogEntry(0x00DF00, "TypeJS/Saber", 0, 0, 16),
    ViewerWeaponCatalogEntry(0x00DF01, "TypeJS/Slicer", 4, 4, 16),
    ViewerWeaponCatalogEntry(0x00E300, "TypeKN/Blade", 2, 2, 0),
    ViewerWeaponCatalogEntry(0x00E301, "TypeKN/Claw", 12, 294, 0),
    ViewerWeaponCatalogEntry(0x00EA00, "TypeME/Mechgun", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x00E900, "TypeRI/Rifle", 6, 6, 7),
    ViewerWeaponCatalogEntry(0x00E101, "TypeRO/Halbert", 3, 3, 11),
    ViewerWeaponCatalogEntry(0x00E102, "TypeRO/Rod", 10, 10, 11),
    ViewerWeaponCatalogEntry(0x00E100, "TypeRO/Sword", 1, 1, 11),
    ViewerWeaponCatalogEntry(0x00DD00, "TypeSA/Saber", 0, 0, 1),
    ViewerWeaponCatalogEntry(0x00EB00, "TypeSH/Shot", 8, 8, 9),
    ViewerWeaponCatalogEntry(0x00DE02, "TypeSL/Claw", 12, 294, 5),
    ViewerWeaponCatalogEntry(0x00DE03, "TypeSL/Katana", 15, 15, 5),
    ViewerWeaponCatalogEntry(0x00DE00, "TypeSL/Saber", 0, 0, 5),
    ViewerWeaponCatalogEntry(0x00DE01, "TypeSL/Slicer", 4, 4, 5),
    ViewerWeaponCatalogEntry(0x00E700, "TypeSS/Sw", 270, 270, 15),
    ViewerWeaponCatalogEntry(0x00E002, "TypeSW/J-Sword", 15, 15, 2),
    ViewerWeaponCatalogEntry(0x00E001, "TypeSW/Slicer", 4, 4, 2),
    ViewerWeaponCatalogEntry(0x00E000, "TypeSW/Sword", 1, 1, 2),
    ViewerWeaponCatalogEntry(0x00EC00, "TypeWA/Wand", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x00CB00, "Tyrell's Parasol", 232, 232, 4),
    ViewerWeaponCatalogEntry(0x00D000, "Unused Weapon38", 237, 237, 2),
    ViewerWeaponCatalogEntry(0x00D100, "Unused Weapon39", 238, 238, 1),
    ViewerWeaponCatalogEntry(0x000B07, "Valkyrie", 269, 269, 11),
    ViewerWeaponCatalogEntry(0x000605, "Varista", 128, 128, 6),
    ViewerWeaponCatalogEntry(0x002000, "Victor Axe", 31, 31, 2),
    ViewerWeaponCatalogEntry(0x009300, "Viridia Card", 178, 178, 18),
    ViewerWeaponCatalogEntry(0x000705, "Visk-235W", 130, 130, 7),
    ViewerWeaponCatalogEntry(0x00B300, "Vivienne", 208, 208, 14),
    ViewerWeaponCatalogEntry(0x000406, "Vjaya", 164, 164, 4),
    ViewerWeaponCatalogEntry(0x000804, "Vulcan", 7, 7, 8),
    ViewerWeaponCatalogEntry(0x000706, "Wals-MK2", 131, 131, 7),
    ViewerWeaponCatalogEntry(0x000C00, "Wand", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x007B00, "WAND", 11, 11, 12),
    ViewerWeaponCatalogEntry(0x009309, "Whitill Card", 178, 286, 18),
    ViewerWeaponCatalogEntry(0x005000, "Windmill", 79, 79, 10),
    ViewerWeaponCatalogEntry(0x008500, "WINDMILL", 79, 79, 10),
    ViewerWeaponCatalogEntry(0x003700, "Wok of Akiko's Shop", 54, 54, 3),
    ViewerWeaponCatalogEntry(0x008901, "Yamato", 171, 171, 15),
    ViewerWeaponCatalogEntry(0x002900, "Yamigarasu", 40, 40, 16),
    ViewerWeaponCatalogEntry(0x008A01, "Yasha", 157, 157, 16),
    ViewerWeaponCatalogEntry(0x006A00, "Yasminkov 2000H", 105, 105, 6),
    ViewerWeaponCatalogEntry(0x006500, "Yasminkov 3000R", 100, 100, 7),
    ViewerWeaponCatalogEntry(0x006B00, "Yasminkov 7000V", 106, 106, 7),
    ViewerWeaponCatalogEntry(0x006C00, "Yasminkov 9000M", 107, 107, 8),
    ViewerWeaponCatalogEntry(0x009308, "Yellowboze Card", 178, 285, 18),
    ViewerWeaponCatalogEntry(0x00BA00, "Yunchang", 215, 215, 4),
    ViewerWeaponCatalogEntry(0x009700, "Zanba", 180, 180, 2),
    ViewerWeaponCatalogEntry(0x000308, "Zero Divide", 253, 253, 3),
)
